import { IncomeInputStoreService } from '@hb/modules/applicants/income-input/income-input-store.service';
import { environment } from '@hb/hypotheken-berekening.environment';
import { StoreService } from '@hb/services/store/store.service';
import { MortgageCalculationService } from '@hb/services/mortgage-calculation/mortgage-calculation.service';
import { ErrorNotificationComponent } from '@hb/modules/main/error-notification/error-notification.component';
import { MainAccordionComponent } from '@hb/modules/main/main-accordion/main-accordion.component';
import { MortgageCalculationComponent } from '@hb/modules/mortgage-calculation/mortgage-calculation.component';
import { AppointmentButtonComponent, NextButtonComponent } from '@hb/modules';
import { CalculationDetailsComponent } from '@hb/modules/main/calculation-details/calculation-details.component';

import { Component, CUSTOM_ELEMENTS_SCHEMA, HostListener, inject, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { ApPanelComponent } from '@ap/panel';
import { ApplicantDetailsResource, EnergyBonusesResource, MortgageCalculationResource } from '@ap/ap-interface-apix-hypotheken-berekening';

@Component({
    selector: 'hypotheken-berekening',
    styleUrls: ['./hypotheken-berekening.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        ErrorNotificationComponent,
        ApPanelComponent,
        MainAccordionComponent,
        MortgageCalculationComponent,
        NextButtonComponent,
        AppointmentButtonComponent,
        CalculationDetailsComponent,
        AsyncPipe
    ],
    templateUrl: './hypotheken-berekening.component.html'
})
export class HypothekenBerekeningComponent implements OnInit {
    private readonly mortgageCalculationResource = inject(MortgageCalculationResource);
    private readonly energyBonusResource = inject(EnergyBonusesResource);
    private readonly applicantDetailsResource = inject(ApplicantDetailsResource);

    readonly incomeInputStoreService = inject(IncomeInputStoreService);
    readonly mortgageCalculationService = inject(MortgageCalculationService);
    readonly store = inject(StoreService);

    @HostListener('window:resize', ['$event'])
    onResize(event: UIEvent): void {
        const target = event.target as Window;
        environment.mobile = target.innerWidth < environment.mobileScreenSize;
    }

    ngOnInit(): void {
        this.mortgageCalculationResource.setApiKey('{<BSPX-RS-HYPOTHEKEN-BEREKENING-API-KEY>}');
        this.energyBonusResource.setApiKey('{<BSPX-RS-HYPOTHEKEN-BEREKENING-API-KEY>}');
        this.applicantDetailsResource.setApiKey('{<BSPX-RS-HYPOTHEKEN-BEREKENING-API-KEY>}');
        environment.mobile = screen.width < environment.mobileScreenSize;
    }

    showButton(): boolean {
        return this.mortgageCalculationService.showMobileDisplay();
    }

    nextQuestion(): void {
        this.incomeInputStoreService.triggerFormFieldValidation();
    }
}
